import { render, staticRenderFns } from "./TopView.vue?vue&type=template&id=2c7585e8&scoped=true&"
import script from "./TopView.vue?vue&type=script&lang=js&"
export * from "./TopView.vue?vue&type=script&lang=js&"
import style0 from "./TopView.vue?vue&type=style&index=0&id=2c7585e8&prod&lang=scss&"
import style1 from "./TopView.vue?vue&type=style&index=1&id=2c7585e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7585e8",
  null
  
)

/* custom blocks */
import block0 from "./TopView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports